export default class ViewSimpleImageVO
{

	// ----------------------------------
	//	Properties
	// ----------------------------------

	defaultValue = '';
	name = "Simple image";
	fieldType = 'simpleImage';
	uiComponent = 'view-simple-image-field';
	description = 'Simply upload a single image.';

	constructor()
	{
		
	}
}